import { createContext } from 'react';

export type SocketContextValue = {
  connected: boolean;
  on: <T>(event: string, callback: (data: T) => void) => void;
  off: <T>(event: string, callback?: (data: T) => void) => void;
  emit: (event: string, data?: unknown) => void;
};

export const SocketContext = createContext<SocketContextValue | undefined>(undefined);
